// Encima de la oficina hay como mucho UNA ventana: el chat de un agente (?agente=), la Sala de Control (?sala=) o la de
// Santi (?santi=). La URL es la verdad (enlaces de Telegram, botón «atrás»); abrir una borra las otras dos en la misma
// navegación (04-11, auditoría de código B3: Ctrl+K desde la Sala abría el chat escondido detrás de ella).
const VENTANAS = ['agente', 'sala', 'santi'] as const;
/** La URL con UNA ventana abierta (o ninguna de ese tipo si `valor` es null): abrir una borra las otras dos. */
export function soloUnaVentana(p: URLSearchParams, ventana: (typeof VENTANAS)[number], valor: string | null): URLSearchParams {
  const n = new URLSearchParams(p);
  if (valor === null) {
    n.delete(ventana);
    return n;
  }
  for (const otra of VENTANAS) if (otra !== ventana) n.delete(otra);
  n.set(ventana, valor);
  return n;
}
